import { DescriptiveError, DescriptiveErrorOptions } from '../../error/DescriptiveError';
import { CodeExchangeQueryParams } from '../types';

interface CodeExchangeParamsNotFoundErrorOptions extends Omit<DescriptiveErrorOptions, 'message'> {
  missingKeys: (keyof CodeExchangeQueryParams)[];
}

export class CodeExchangeParamsNotFoundError extends DescriptiveError {
  constructor({ missingKeys = [], ...options }: CodeExchangeParamsNotFoundErrorOptions) {
    super({
      ...options,
      message: `Missing expected Auth0 code exchange query parameters${missingKeys.length ? `: ${missingKeys.join(', ')}` : ''}`,
    });
    this.name = 'CodeExchangeParamsNotFoundError';
  }
}
